export default "__VITE_ASSET__kmFcCyfC__"